import React from 'react';
import _ from 'lodash';
import { Box, FormControl, InputLabel, Select, MenuItem, Typography, Stack, Button } from '@mui/material';
import { useQuery } from 'react-fetching-library';
import { getFormListAction } from '../../services/request';
import { FormPanel } from './FormPanel';

import { useFullScreen } from '../../services/hooks';

export const FormListPanel = () => {
  const { loading, payload, error } = useQuery(getFormListAction());
  const [forms, setForms] = React.useState([]);
  const [selectedForm, setSelectedForm] = React.useState('');
  const [boskieWakacje, setBoskieWakacje] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const margin = useFullScreen() ? '0%' : '0%';

  React.useEffect(() => {
    if (!error && !loading) {
      setForms(payload);
    }
  }, [loading]);

  const handleChangeForm = val => {
    setTimeout(() => {
      setBoskieWakacje(false);
      setSubmitted(false);
      setSelectedForm(val);
    }, 300);
    setSelectedForm('');
  };

  return (
    <Box display="flex" flexDirection="column" style={{ marginLeft: margin, marginRight: margin }}>
      <FormControl>
        <InputLabel>Formularze</InputLabel>
        <Select
          value={selectedForm}
          label="forms"
          onChange={e => handleChangeForm(e.target.value)}
        >
          {!_.isEmpty(forms)
            ? _.map(forms, (obj, idx) => (
              <MenuItem value={obj} key={idx} style={{ whiteSpace: 'normal' }}>
                {obj.identifier} - wersja {obj.version}
              </MenuItem>
            ))
            : []}
        </Select>
      </FormControl>
      { _.isObject(selectedForm) && (selectedForm.identifier == 'lato' || selectedForm.identifier == 'lato-pracownicy')
        ? !submitted ? <Stack sx={{ mt: 5, p: 3 }} alignItems="center">
          <InputLabel id="seasons"><Typography color="primary">Wczytać formularz boskich wakacji?</Typography></InputLabel>
          <Select
            sx={{ mt: 2, mb: 2 }}
            variant="outlined"
            labelId="seasons"
            value={boskieWakacje}
            label="Sezony"
            onChange={e => setBoskieWakacje(e.target.value)}
          >
            <MenuItem value={false}>NIE</MenuItem>
            <MenuItem value={true}>TAK</MenuItem>
          </Select>
          <Button variant="contained" onClick={() => setSubmitted(true)}>Zatwierdź</Button>
        </Stack> : <FormPanel form={selectedForm} boskieWakacje={boskieWakacje} />

        : _.isObject(selectedForm)
          ? <FormPanel form={selectedForm} />
          : null

      }
    </Box>
  );
};
